@if (software && artifact) {
  <div class="box">
    <div class="box-row header">
      <app-header-bar
        [title]="software.name"
        [backRoute]="'/software/' + softwareId"
        [autoTranslateTitle]="software === undefined"
      ></app-header-bar>
    </div>
    <div class="card mb-3 pt-3 mt-2">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center mb-2">
          @if (artifact.version) {
            <h2 class="mb-0 me-3">
              {{ 'software.version' | translate }} {{ artifact.version }}
              @if (artifact.size) {
                <span> ({{ artifact.size | fileSize }})</span>
              }
            </h2>
          }
          @if (software.platform) {
            <span class="badge platform-label me-2">{{
              software.platform.name
            }}</span>
          }
          @if (software.type) {
            <span class="badge type-label me-2">{{ software.type.name }}</span>
          }
          @if (artifact.releaseType) {
            <span class="badge release-type-label me-2">{{
              artifact.releaseType!.name
            }}</span>
          }
          @if (artifact.status === SoftwareArtifactStatus.WITHDRAWN) {
            <span class="badge withdrawn-label me-2">{{
              'software.artifact.statusItems.withdrawn' | translate
            }}</span>
          }
        </div>
        @if (artifact.status !== SoftwareArtifactStatus.WITHDRAWN) {
          <app-software-artifact-download-button
            class="me-2"
            [artifact]="artifact"
          ></app-software-artifact-download-button>
        }
      </div>
      @if (software.description) {
        <markdown [data]="software.description"></markdown>
      }
      <div class="d-flex flex-column text-addition">
        @if (artifact.buildNumber) {
          <span
            ><b>{{ 'software.artifact.buildNumber' | translate }}</b
            >: {{ artifact.buildNumber }}</span
          >
        }
        @if (isAdmin) {
          @if (artifact.branchName) {
            <span
              ><b>{{ 'software.artifact.branchName' | translate }}</b
              >: {{ artifact.branchName }}</span
            >
          }
          @if (artifact.creationDate) {
            <span
              ><b>{{ 'software.artifact.creationDate' | translate }}</b
              >: {{ artifact.creationDate | dateTime }}</span
            >
          }
        }
        @if (
          artifact.releaseDate &&
          artifact.status === SoftwareArtifactStatus.RELEASED
        ) {
          <span
            ><b>{{ 'software.artifact.releaseDate' | translate }}</b
            >: {{ artifact.releaseDate | dateTime }}</span
          >
        }
      </div>
      @if (firmwareBundles.length > 0) {
        <a
          data-bs-toggle="collapse"
          class="me-2"
          [href]="'#' + artifact.id + '_firmware_bundle'"
          role="button"
          aria-expanded="false"
          >{{ 'software.toggleFirmwareBundle' | translate }}</a
        >
        <div class="collapse mt-2" [id]="artifact.id + '_firmware_bundle'">
          <div class="d-flex flex-column text-addition">
            <label [for]="'hardware-version-selector-single-' + artifact.id"
              ><b>{{
                'software.artifact.firmwareBundle.hardwareVersionSelector'
                  | translate
              }}</b></label
            >
            <p-select
              [inputId]="'hardware-version-selector-single-' + artifact.id"
              class="mb-2"
              [ngModel]="selectedHardwareVersion ?? hardwareVersionOptions[0]"
              (ngModelChange)="onHardwareVersionChange($event)"
              [options]="hardwareVersionOptions"
              [fluid]="true"
            >
              <ng-template let-hardwareVersionOption pTemplate="selectedItem">
                @if (hardwareVersionOption === noHardwareVersionOptionValue) {
                  {{
                    'software.artifact.firmwareBundle.hardwareVersionUnknown'
                      | translate
                  }}
                } @else {
                  {{ hardwareVersionOption }}
                }
              </ng-template>
              <ng-template let-hardwareVersionOption pTemplate="item">
                @if (hardwareVersionOption === noHardwareVersionOptionValue) {
                  {{
                    'software.artifact.firmwareBundle.hardwareVersionUnknown'
                      | translate
                  }}
                } @else {
                  {{ hardwareVersionOption }}
                }
              </ng-template>
            </p-select>
            @if (selectedFirmwareBundle; as selectedBundle) {
              @if (selectedBundle.bundleName) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.bundleName' | translate
                  }}</b
                  >: {{ selectedBundle.bundleName }}</span
                >
              }
              @if (selectedBundle.hardwareVersion) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.hardwareVersion'
                      | translate
                  }}</b
                  >: {{ selectedBundle.hardwareVersion }}</span
                >
              }
              @if (selectedBundle.firmwareVersion) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.firmwareVersion'
                      | translate
                  }}</b
                  >: {{ selectedBundle.firmwareVersion }}</span
                >
              }
              @if (selectedBundle.bootloaderVersion) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.bootloaderVersion'
                      | translate
                  }}</b
                  >: {{ selectedBundle.bootloaderVersion }}</span
                >
              }
              @if (selectedBundle.bleFirmwareVersion) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.bleFirmwareVersion'
                      | translate
                  }}</b
                  >: {{ selectedBundle.bleFirmwareVersion }}</span
                >
              }
              @if (selectedBundle.bleScriptVersion) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.bleScriptVersion'
                      | translate
                  }}</b
                  >: {{ selectedBundle.bleScriptVersion }}</span
                >
              }
              @if (selectedBundle.imagerFirmwareVersion) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.imagerFirmwareVersion'
                      | translate
                  }}</b
                  >: {{ selectedBundle.imagerFirmwareVersion }}</span
                >
              }
              @if (selectedBundle.touchFirmwareVersion) {
                <span
                  ><b>{{
                    'software.artifact.firmwareBundle.touchFirmwareVersion'
                      | translate
                  }}</b
                  >: {{ selectedBundle.touchFirmwareVersion }}</span
                >
              }
            }
          </div>
        </div>
      }
      @if (artifact.changelog) {
        <hr />
        <div class="latest-changes">
          <h3>{{ 'software.latestChanges' | translate }}</h3>
          <markdown [data]="artifact.changelog"></markdown>
        </div>
      }
    </div>
  </div>
}
